// extracted by mini-css-extract-plugin
export default {"error":"DefaultError_error__2qHkW"};